import React, {Component} from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';

// Components
import Header from '../components/Header';
import {Pages} from '../common/vars';

// Elements
import FooterLogo from "../elements/FooterLogo";
import TextBlock from "../elements/TextBlock";
import ImageGrid from "../components/ImageGrid";

// Styles

class PhotographyPage extends Component {

    page = Pages[3];

    content = this.page.content;

    render() {
        return (
            <article className="page portfolio">
                <Header image={this.page.img} svg={this.page.svg} title={this.page.name} subtitle={this.page.subtitle}/>
                <div className="page__content">
                    <TextBlock title={this.content[0].title} content={this.content[0].content}
                               className="text-block--first text-block--left text-block--small-left"/>
                    <ImageGrid/>
                    <TextBlock content={this.content[1].content}/>
                </div>
                <FooterLogo/>
            </article>
        );
    }
}

const mapStateToProps = state => {
    return {
        photography: state.photography,
    }
};

export default withRouter(connect(mapStateToProps)(PhotographyPage));


// WEBPACK FOOTER //
// ./src/js/pages/PhotographyPage.js